import { Injectable, inject } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  ConsultantAttendanceRequest,
  ConsultantAttendanceResponse,
} from '../models/consultant-attendance.model';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ConsultantAttendanceService {
  private readonly API_URL = '/generic-flow/consultant-attendance';
  private apiService = inject(ApiService);


  submitConsultantAttendance(
    payload: ConsultantAttendanceRequest
  ): Observable<ConsultantAttendanceResponse> {
    const headers = new HttpHeaders({
      'X-API-Key': environment.apiKey,
      'Content-Type': 'application/json',
    });

    return this.apiService.post<ConsultantAttendanceResponse>(
      this.API_URL,
      payload,
      { headers }
    );
  }
}
